import ComponentStructure from '../basic'

export default class I18nForLwTabs extends ComponentStructure {
  name = 'lw-tabs'
  properties = []

  getHtmlElement () {
    return null
  }

  getPropertyShownElement (property: string) {
    return null
  }

  getChildComponents () {
    return this.component.components || []
  }
}
